import { render } from "./FDMessengerBox.vue?vue&type=template&id=40485004&scoped=true"
import script from "./FDMessengerBox.vue?vue&type=script&lang=js"
export * from "./FDMessengerBox.vue?vue&type=script&lang=js"

import "./FDMessengerBox.vue?vue&type=style&index=0&id=40485004&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40485004"]])

export default __exports__